import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { DiscountPersonaResponseModel } from '@/types/clarityLens/response/salesLens'

export const getDiscountPersona = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemGroupName: string
): Promise<DiscountPersonaResponseModel[]> => {
  try {
    const response = await axios.get(
      `${BASE_URL}/daily-sales-lens/discounts/persona`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          branch_names: branchName,
          item_group_name: itemGroupName,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
